
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import type { FaqCategory } from '../types'

@Component
export default class CategoryTags extends Vue {
  @Prop({ type: Array, required: true }) readonly categories!: FaqCategory[]
  @Prop({ type: String, default: '' }) readonly activeCategoryId!: string

  /** Whether tags bar is in fixed (collapsed) mode */
  isFixed = false

  /** Natural height of tags bar before becoming fixed (for placeholder) */
  tagsNaturalHeight = 0

  /** Scroll Y position at which tags become fixed */
  private fixedThreshold = 0

  $refs!: {
    tagsEl: HTMLElement;
    scrollContainer: HTMLDivElement;
    [key: string]: HTMLButtonElement[] | HTMLDivElement | HTMLElement;
  }

  mounted(): void {
    this.$nextTick(() => {
      this.measureThreshold()
    })
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy(): void {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }

  @Watch('activeCategoryId')
  onActiveCategoryIdChange(newId: string): void {
    if (newId && this.isFixed) {
      this.$nextTick(() => {
        this.scrollToActiveTag(newId)
      })
    }
  }

  /** Record the natural position and height of the tags bar */
  private measureThreshold(): void {
    const el = this.$refs.tagsEl
    if (!el) return
    this.tagsNaturalHeight = el.offsetHeight
    // threshold = distance from page top to bottom of tags bar
    this.fixedThreshold = el.getBoundingClientRect().top + window.scrollY + el.offsetHeight
  }

  private onScroll(): void {
    const shouldFix = window.scrollY >= this.fixedThreshold
    if (shouldFix !== this.isFixed) {
      this.isFixed = shouldFix
      if (shouldFix && this.activeCategoryId) {
        this.$nextTick(() => this.scrollToActiveTag(this.activeCategoryId))
      }
    }
  }

  private onResize(): void {
    // Re-measure after resize in case layout changed
    if (!this.isFixed) {
      this.measureThreshold()
    }
  }

  handleTagClick(category: FaqCategory): void {
    console.log('click')
    this.$emit('category-click', category.id)
  }

  scrollToActiveTag(categoryId: string): void {
    const tagRefs = this.$refs[`tag-${categoryId}`]
    const tagElement = Array.isArray(tagRefs) ? tagRefs[0] : tagRefs

    if (tagElement && this.$refs.scrollContainer) {
      const container = this.$refs.scrollContainer
      const scrollLeft =
        (tagElement as HTMLElement).offsetLeft -
        container.clientWidth / 2 +
        (tagElement as HTMLElement).clientWidth / 2
      container.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' })
    }
  }
}
